import type { CashbackType } from '@/backend/market'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { UserGroupMiniEntity } from '@/features/userGroup/domain/entities/UserGroupMiniEntity'
import type { CashbackBranchRatioEntity } from './CashbackBranchRatioEntity'
import type { CashbackRegionsEntity } from './CashbackRegionsEntity'
import type { CashbackTranslationEntity } from './CashbackTranslationEntity'
import type { CashbackVariationEntity } from './CashbackVariationEntity'

export class CreateCashbackOfferEntity {
  startDate?: string
  endDate?: string
  isActive?: boolean
  type?: CashbackType
  serviceValue?: number
  branchValue?: number
  readonly baseValue?: number
  minCartAmount?: number | null
  maxCashbackAmount?: number | null
  branchCap?: number | null
  isPaymentTypeFree?: boolean
  variations?: Array<CashbackVariationEntity> | null
  atNumberOfOrders?: Array<number> | null
  maxUsage?: number | null
  maxUserUsage?: number | null
  priority?: number | null
  isUserFree?: boolean
  users?: Array<UserMiniEntity> | null
  isGroupFree?: boolean
  groups?: Array<UserGroupMiniEntity> | null
  isChannelFree?: boolean
  channels?: Array<ChannelMiniEntity> | null
  isServiceFree?: boolean
  services?: Array<ServiceMiniEntity> | null
  isIncludeBranchesFree?: boolean
  includeBranches?: Array<BranchMiniEntity> | null
  isExcludeBranchesFree?: boolean
  excludeBranches?: Array<BranchMiniEntity> | null
  branchRatios?: Array<CashbackBranchRatioEntity> | null
  regions?: Array<CashbackRegionsEntity> | null
  translations?: Array<CashbackTranslationEntity> | null
}
